import { z } from "zod";
import { GROUP_STATUSES } from "../domain/types.js";
import { idSchema, optionalText, requiredText } from "./common.js";
export const createGroupSchema = z.object({
    name: requiredText(80, "nome"),
    description: optionalText(300).nullable(),
    /** Um emoji so, para dar cara ao grupo na lista. */
    emoji: z.string().trim().max(8).optional(),
    /**
     * Atalho do fluxo rapido: cria o grupo ja com participantes placeholder,
     * so pelo nome, sem passar por outra tela.
     */
    memberNames: z.array(requiredText(80, "nome")).max(50).optional(),
    /** Pessoas que ja existem no caderninho e vao entrar junto. */
    memberIds: z.array(idSchema).max(50).optional(),
});
export const updateGroupSchema = z.object({
    name: requiredText(80, "nome").optional(),
    description: optionalText(300).nullable(),
    emoji: z.string().trim().max(8).optional(),
    status: z.enum(GROUP_STATUSES).optional(),
});
/** Entra alguem que ja existe no caderninho, ou cria um placeholder na hora. */
export const addMemberSchema = z
    .object({
    personId: idSchema.optional(),
    displayName: requiredText(80, "nome").optional(),
})
    .refine((data) => Boolean(data.personId) !== Boolean(data.displayName), {
    message: "Escolha uma pessoa existente ou digite um nome novo.",
    path: ["displayName"],
});
//# sourceMappingURL=group.js.map